export default "__VITE_ASSET__D6JBu2HZ__"